<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';

    export let closeCallback;

    let wsServices = null;
    const load = () => {

        const onSuccess = result => {
            wsServices = result;
        };

        const onFailure = err => {
            console.log(err);
        };

        R.handle(R.ws_service.index, {is_active: 1}, onSuccess, onFailure, LOADER.POPUP);
    }


    const close = (param) => {
        wsServices = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();
</script>

{#if wsServices != null}
    <Modal title="Επιλογή υπηρεσίας" modalSm closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            {#if !wsServices.length}

            {:else}
                <p>
                    Επιλέξτε το είδος της υπηρεσίας που θα δημιουργήσετε.
                </p>
                {#each wsServices as item}
                    <button class="btn btn-default btn-block mb-1" on:click={ () => close(item) }>
                        { item.name }
                    </button>
                {/each}
            {/if}
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link" on:click="{ () => close() }">Ακύρωση</div>
            </div>
        </div>
    </Modal>
{/if}